// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".the-warning h4[data-v-3b8b0ac5]{display:inline-block;text-align:center}", "",{"version":3,"sources":["webpack://./resources/assets/js/components/VJSModals/ThirdPartyUploadApproveModal.vue"],"names":[],"mappings":"AAAA,iCAAA,oBAAA,CAAA,iBAAA","sourcesContent":[".the-warning h4{display:inline-block;text-align:center}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
